// Constants
// Actions
import { ViewDataFetchAction, ViewForceDataFetchAction, ViewRenderAction } from "@ms/uno-actions/lib/local/legacyPlanner/performanceCollection/PerformanceCollectionAction";
export class PerformanceCollectionModule {
    setViewRenderState(viewName, state, extraData) {
        this.dispatcher.dispatchActionAsync(new ViewRenderAction(viewName, state, extraData));
    }
    setViewDataFetchState(viewName, viewId, state, extraData) {
        this.dispatcher.dispatchActionAsync(new ViewDataFetchAction(viewName, viewId, state, extraData));
    }
    setViewForceFetchDataState(viewName, viewId, shouldForceFetch) {
        this.dispatcher.dispatchActionAsync(new ViewForceDataFetchAction(viewName, viewId, shouldForceFetch));
    }
    constructor(dispatcher){
        this.dispatcher = dispatcher;
    }
}
